import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as actions from './course-player.actions';
import * as fromCoursePlayer from './course-player.reducer';
import { normalize, schema } from 'normalizr';
import { environment } from '../../../environments/environment';
import { CourseService } from '@app/_services/course.service';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ConsoleLogger } from '@aws-amplify/core';

@Component({
  selector: 'app-course-player',
  templateUrl: './course-player.component.html'  
})
export class CoursePlayerComponent implements OnInit, OnDestroy {
  coursePlayerState$: Observable<any>
  currentInterval: any;  
  loading: boolean = true;

  constructor(
    private courseService: CourseService, 
    private store: Store<{ coursePlayerState: fromCoursePlayer.State }>, 
    private http: HttpClient,
    private route: ActivatedRoute) {
    // TODO: This stream will connect to the current store `count` state
    this.coursePlayerState$ = store.select(fromCoursePlayer.getCoursePlayerState);
  }
  ngOnDestroy(): void {
    this.store.dispatch(new actions.Close());
  }

  async ngOnInit(): Promise<void> {
    
    // 1. Load Saved History if url is blank
    // 2. Load from url?
    // 3. Load form localstorage?
    
    const courseId = await this.route.snapshot.data.courseId;    
    
    const progress$ = this.http.get<any>(`${environment.apiUrl}/api/user/course/${courseId}`, {});
    const courseData$ = this.http.get<any>(`${environment.apiUrl}/api/course/courses/data/${courseId}`, {});
    
    combineLatest(progress$, courseData$).subscribe(([progress, courseData]) => {

      const page = new schema.Entity('pages');    
      const unit = new schema.Entity('units', {
        pages: [page]
      });  
      const module = new schema.Entity('modules', {
        units: [unit]
      });           

      const normalizedData = normalize(courseData.modules, [module]);      
      this.courseService.saveCourseData(courseData._id, normalizedData);

      if (progress) {
        this.store.dispatch(new actions.LoadProgress(
            progress.state
          ));
        this.loading = false;        
      }
      else {        
                                        
        this.initialLoad(courseData.modules, courseId);
        this.loading = false;
      }      
    });
  }  
   
  initialLoad(courseData, courseId) {

    console.log("COURSE ID", { id: courseId })

    this.store.dispatch(new actions.Load(
      courseData[0].units[0].pages.map(o => {
        return {
          id: o.id,
          pageUrl: o.image,
          content: o.content,
          audioIndex: o.audio.length > 0 ? o.audio[0] : -1,
          isStart: o.isStart,
          isEnd: o.isEnd,
          nextModule: o.nextModule,
          nextModuleId: o.nextModuleId,
          nextUnit: o.nextUnit,
          nextUnitId: o.nextUnitId,
          prevModule: o.prevModule,
          prevModuleId: o.prevModuleId,
          prevUnit: o.prevUnit,
          prevUnitId: o.prevUnitId,
          unitId: o.unitId,
          moduleId: o.moduleId,
          audioCount: o.audioCount
        }
      }), 
      courseId,
      courseData[0].units[0].audioUrl,       
      courseData[0].name, 
      courseData[0].units[0].name
    ));
  }  
}
